import PathManagement, { XhrQueryParam } from '../path-management';
import { getAction, patchResponseByUrl } from '../xhr';
import { ArticuloSearch } from './articulo';

const searchAction = 'searchKey';
const searchSuggestionAction = 'Diccionario';

interface SearchRes {
  nPages: number;
  nResults: number;
  results: ArticuloSearch[];
}

interface SearchSuggestion {
  key: string;
}

/**
 * @param key
 */
export const searchSuggestions = async (key: string): Promise<SearchSuggestion[]> => {
  const query: XhrQueryParam[] = [{ name: 'searchKey', value: key }];
  const res = await getAction<SearchSuggestion[]>(searchSuggestionAction, query);

  return res;
};

export const search = async (idListFromBusqueda: string[]): Promise<SearchRes> => {
  // const query: XhrQueryParam[] = [
  //   { name: 'searchKey', value: key },
  //   { name: 'page', value: page },
  //   { name: 'resultsPerPage', value: resultsPerPage },
  // ];
  let _pathManager = new PathManagement();

  let url = _pathManager.getSearchKeyUrl();

  // let url = '/' + searchAction;

  const res = await patchResponseByUrl<SearchRes>(url, { idList: idListFromBusqueda });

  // const res = await getAction<SearchRes>(searchAction, query);

  return res;
};
